import React from 'react';

const CustomNextPrevious = () => (
  <></>
);

export default CustomNextPrevious;
